export const COLLAPSE_MENU = 'COLLAPSE_MENU';
export const COLLAPSE_TOGGLE = 'COLLAPSE_TOGGLE';
export const FULL_SCREEN = 'FULL_SCREEN';
export const FULL_SCREEN_EXIT = 'FULL_SCREEN_EXIT';
export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const NAV_CONTENT_LEAVE = 'NAV_CONTENT_LEAVE';
export const NAV_COLLAPSE_LEAVE = 'NAV_COLLAPSE_LEAVE';

export const RESET = 'RESET';

export const HANDLE_USERS = "HANDLE_USERS";
export const HANDLE_CUSTOMER = "HANDLE_CUSTOMER";
export const HANDLE_CUSTOMER_JOBCARD = "HANDLE_CUSTOMER_JOBCARD";
export const HANDLE_JOB_CARD = "HANDLE_JOB_CARD";
export const SET_DEFAULT_JOB_CARD = "SET_DEFAULT_JOB_CARD";
export const SET_GLOBAL_DROPDOWN = "SET_GLOBAL_DROPDOWN";

export const HANDLE_REPORT = "HANDLE_REPORT";

export const HANDLE_PRODUCT = "HANDLE_PRODUCT";
export const HANDLE_USER_PRODUCT = "HANDLE_USER_PRODUCT";

export const HANDLE_JOB_CARD_NEW = "HANDLE_JOB_CARD_NEW";
export const HANDLE_JOB_CARD_SER = "HANDLE_JOB_CARD_SER";
export const HANDLE_JOB_CARD_AMC = "HANDLE_JOB_CARD_AMC";
export const HANDLE_JOB_CARD_ONLINE_SERVICE = "HANDLE_JOB_CARD_ONLINE_SERVICE";

export const HANDLE_JOB_CARD_SITE_SERVICE = "HANDLE_JOB_CARD_SITE_SERVICE";

export const HANDLE_JOB_CARD_AMC_STATUS = "HANDLE_JOB_CARD_AMC_STATUS";

export const HANDLE_INFORMATION = "HANDLE_INFORMATION";
export const HANDLE_COMMON = "HANDLE_COMMON";

export const HANDLE_FOLLOW_UP = "HANDLE_FOLLOW_UP";

export const HANDLE_JOB_CARD_PENDING = "HANDLE_JOB_CARD_PENDING";

export const HANDLE_ATTENDANCE = "HANDLE_ATTENDANCE";
export const HANDLE_DOCUMENTATION = "HANDLE_DOCUMENTATION";

export const HANDLE_RE_AMC = "HANDLE_RE_AMC";

export const HANDLE_OFFLINE = "HANDLE_OFFLINE";